import { render, staticRenderFns } from "./order_detail.vue?vue&type=template&id=1bbdb0fb&scoped=true&"
import script from "./order_detail.vue?vue&type=script&lang=js&"
export * from "./order_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_detail.vue?vue&type=style&index=0&id=1bbdb0fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbdb0fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bbdb0fb')) {
      api.createRecord('1bbdb0fb', component.options)
    } else {
      api.reload('1bbdb0fb', component.options)
    }
    module.hot.accept("./order_detail.vue?vue&type=template&id=1bbdb0fb&scoped=true&", function () {
      api.rerender('1bbdb0fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/net_bar/order/order_detail.vue"
export default component.exports